import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

function TimeTracker() {
  const percentage = 80; // static for now

  return (
    <div className="card p-4 text-center">
      <h5>Time Tracker</h5>

      <div style={{ width: "120px", margin: "auto" }}>
        <CircularProgressbar value={percentage} text={`${percentage}%`} />
      </div>

      <p className="mt-3">Working Hours</p>
    </div>
  );
}

export default TimeTracker;